import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/app/shell/app-shell";
import { ensureMe } from "@/hooks/data";
import { apiQuery } from "@/lib/api/hooks";
import { isApiError } from "@/lib/api/errors";
import { adoptSession } from "@/lib/auth";
import { isOnboardingDone } from "@/lib/onboarding";

/** Everything behind sign-in. New orgs without a connected channel go through onboarding first. */
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    try {
      const me = await ensureMe(context.queryClient);
      const orgId = adoptSession(me);
      // a login with no organization: create one first (never a broken onboarding / org page)
      if (!orgId) throw redirect({ to: "/create-org" });
      const accounts = await context.queryClient.ensureQueryData(apiQuery("accounts"));
      // onboarding done per org lives on the server (ALP-79); the device flag is only an offline fallback
      if (accounts.length === 0 && !isOnboardingDone(me, orgId)) throw redirect({ to: "/onboarding" });
    } catch (e) {
      if (isApiError(e) && e.isUnauthorized) throw redirect({ to: "/login", search: { redirect: location.href === "/home" ? undefined : location.href } });
      throw e;
    }
  },
  component: AppShell,
});
